import { IComponentOptions } from 'angular';

export const StudentSnapshotPanelComponent: IComponentOptions = {
  template: require('./student-snapshot-panel.html'),
  bindings: {
    student: '=',
  },
  controller: 'StudentSnapshotPanelCtrl',
};

angular.module('nv.singleStudent').component('studentSnapshotPanel', StudentSnapshotPanelComponent);
